import { supabase } from '../lib/supabase';

/**
 * Fire-and-forget error logger — never blocks user flow.
 * Logs to Supabase error_logs table with full context.
 */
export const logError = async ({
  error,
  componentName = '',
  actionName = '',
  screenName = '',
  context = {},
  userId = null,
  severity = 'error',
}) => {
  try {
    // Get current user if not provided
    let resolvedUserId = userId;
    if (!resolvedUserId) {
      try {
        const { data: { user } } = await supabase?.auth?.getUser();
        resolvedUserId = user?.id || null;
      } catch {
        // ignore auth errors in logger
      }
    }

    const errorMessage = error instanceof Error
      ? error.message
      : (typeof error === 'string' ? error : JSON.stringify(error));

    const stackTrace = error instanceof Error ? (error.stack || '') : '';

    await supabase?.from('error_logs')?.insert({
      user_id: resolvedUserId,
      error_message: errorMessage?.slice(0, 2000),
      stack_trace: stackTrace?.slice(0, 5000),
      component_name: componentName?.slice(0, 100),
      action_name: actionName?.slice(0, 100),
      screen_name: screenName?.slice(0, 100),
      user_agent: navigator?.userAgent?.slice(0, 500) || '',
      context: context || {},
      severity,
      created_at: new Date().toISOString(),
    });
  } catch {
    // Silently fail — logging must never break user flow
    if (process.env.NODE_ENV === 'development') {
      console.warn('[logError] Failed to log error to Supabase');
    }
  }
};

export default logError;
